import React from 'react';

const Chips = ({ val, margin }) => {
  return (
    <div className='chips-wrapper'>
      <img src="/images/tournamentCasino/poker-chip.svg" alt="Chip"/>
      <span style={{marginLeft: `${margin}px`}}>{parseFloat(val)}</span>
    </div>
  );
};
export default Chips;
